import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import SolarService from "./SolarService";

const initialState = {
    solar_contracts: [],
    analysis: [],
    isLodaing: false,
    isSuccess: false,
    isError: false,
    massage: null,
};

export const GetAllSolarContractsMethod = createAsyncThunk(
    "solarContracts/index",
    async (data, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return SolarService.GetAllSolarContractsMethod(data, token);
        } catch (error) {
            const message = error.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const SolarContractAnalysis = createAsyncThunk(
    "solarContracts/analysis",
    async (data, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.mainUser.data.token;
            return SolarService.SolarAnalysis(data, token);
        } catch (error) {
            const message = error.message;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

const SolarReducer = createSlice({
    name: "SolarReducer",
    initialState,
    reducers: {
        resetSolar: (state) => {
            state.isLodaing = false;
            state.isSuccess = false;
            state.isError = false;
            state.massage = null;
        },
    },

    extraReducers: {
        [GetAllSolarContractsMethod.pending]: (state) => {
            state.isLodaing = true;
        },
        [GetAllSolarContractsMethod.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.isStateSuccess = true;
            state.solar_contracts = action.payload;
        },
        [GetAllSolarContractsMethod.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isStateErorr = true;
            state.massage = action.payload;
            state.analysis = [];
        },

        // Get Solar Contract Analysis

        [SolarContractAnalysis.pending]: (state) => {
            state.isLodaing = true;
        },
        [SolarContractAnalysis.fulfilled]: (state, action) => {
            state.isLodaing = false;
            state.analysis = action.payload;
            state.isStateSuccess = true;
        },
        [SolarContractAnalysis.rejected]: (state, action) => {
            state.isLodaing = false;
            state.isStateErorr = true;
            state.massage = action.payload;
            state.analysis = [];
        },
    },
});

export const { resetSolar } = SolarReducer.actions;
export default SolarReducer.reducer;
